export default "__VITE_ASSET__CbswCtVa__"